import FormattedMessage from 'I18n/components/FormattedMessage';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalRequestAccessHeadingI18n(props) {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.KNOWLEDGE_ARTICLE"
        });
      }
    case 'QUOTE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.QUOTE"
        });
      }
    case 'SOCIAL_BROADCAST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.heading.SOCIAL_BROADCAST"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
}
export function ApprovalRequestAccessDescriptionI18n(props) {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.KNOWLEDGE_ARTICLE"
        });
      }
    case 'QUOTE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.QUOTE"
        });
      }
    case 'SOCIAL_BROADCAST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.description.SOCIAL_BROADCAST"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
}
export function ApprovalRequestAccessStepTwoI18n(props) {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.KNOWLEDGE_ARTICLE"
        });
      }
    case 'QUOTE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.QUOTE"
        });
      }
    case 'SOCIAL_BROADCAST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepTwo.SOCIAL_BROADCAST"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
}
export function ApprovalRequestAccessStepThreeI18n(props) {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.KNOWLEDGE_ARTICLE"
        });
      }
    case 'QUOTE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.QUOTE"
        });
      }
    case 'SOCIAL_BROADCAST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.steps.stepThree.SOCIAL_BROADCAST"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
}